/** Both quote characters are encoded, not just the double quote: a value substituted into a
 * single-quoted attribute can break out of it just as easily as one in a double-quoted attribute. */
export function escapeHtml(value: string): string {
  return (value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
